module.exports = __webpack_public_path__ + "img/logo-simple.88d6befc.svg";